import React, { Component } from "react";
import "./Logo.css";

class Logo extends Component {
  render() {
    return (
      <img
        src="/images/pages/2025_Logo_Cloud.png"
        // src="/images/pages/2025_Logo_Rec.png"
        // src="/images/pages/2025_Logo_Mini_Recs.png"
        alt="skywardLogo"
        id="skywardLogo"
      />
    );
  }
}

export default Logo;
